if (!customElements.get('featured-collection-button')) {
  class FeaturedCollectionButton extends HTMLElement {
    constructor() {
      super();
      this.collectionHandle = this.dataset.collectionHandle;
      this.text = this.textContent;
      this.nextUrl = `/collections/${this.collectionHandle}?page=2`;

      this.classList.add(
        'button--text',
        'primary__color',
        'fw--500',
        'text__uppercase',
        'text__underline',
        'flex',
        'fd--row',
        'button-product-list',
        'featured-collection-btn__load-more',
        'mt-30',
        'mb-30'
      );

      this.addEventListener('click', this.loadMore.bind(this));
    }

    loadMore() {
      const section = this.closest('.featured-collection__grid-layout');
      const gridProducts = section.querySelector('.grid-products');
      const productsHiddenOnMobile = parseInt(gridProducts.dataset.productsHiddenOnMobile, 10);

      fetch(`${this.nextUrl}&sections=grid-products`)
        .then(response => response.json())
        .then(data => {
          const newProducts = data['grid-products'];

          const element = document.createElement('div');
          element.innerHTML = newProducts;
          const gridCells = element.querySelectorAll('.grid-cell');
          const nextArrow = element.querySelector('.next-arrow');

          this.updateMobileProductsDisplay(gridCells, productsHiddenOnMobile);

          if (nextArrow != null) {
            this.nextUrl = nextArrow.href;
          } else {
            this.nextUrl = null;
            this.style.display = 'none';
          }

          gridProducts.append(...gridCells);
        });
    }

    updateMobileProductsDisplay(gridCells, productsHiddenOnMobile) {
      if (productsHiddenOnMobile > 0) {
        const lastGridCells = Array.from(gridCells).slice(-productsHiddenOnMobile);
        lastGridCells.forEach(cell => {
          cell.style.display = 'block';
        });
      }
    }
  }
  customElements.define('featured-collection-button', FeaturedCollectionButton);
}
